




import { Component, Prop, Vue } from 'vue-property-decorator';
import { Styled }               from '@/shared/UI/Styled';

@Component
export default class BaseImage extends Vue implements Styled {
  @Prop()
  private src: string;

  @Prop({ default: 'Image' })
  private alt?: string;

  @Prop({ default: false })
  private adjustSize?: boolean;

  @Prop({ default: 'center' })
  private align?: string;

  get styled() {
    return {
      styles: {
        'background-image': `url('${this.src}')`,
        'background-position-x': `${this.align}`
      },
      image: {
        'image--adjust': this.adjustSize
      }
    };
  }
}
